import { BillingData } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { mpsActivationInfoAtom } from '../recoil/atoms/mpsActivationInfoAtom';
import type { MpsStatusResponseDTO } from 'gw-edge-client/dist/types/dto/bc/edge/capabilities/billing/dto';

const RETRY_TIMEOUT = 3000;
const MAX_RETRIES = (3 * 60 * 1000) / RETRY_TIMEOUT;

const wait = async (duration: number): Promise<void> => {
    await new Promise((resolve) => setTimeout(resolve, duration));
};

export function useAwaitGetMpsStatus(): {
    awaitGetMpsStatus: () => Promise<MpsStatusResponseDTO>;
} {
    const { policeNummer } = useRecoilValue(mpsActivationInfoAtom);

    const awaitGetMpsStatus = async (): Promise<MpsStatusResponseDTO> => {
        let retries = 0;
        let response: MpsStatusResponseDTO | null = null;

        try {
            response = await BillingData.getMpsStatus(policeNummer);
            let status = response.status;

            while (status === 'Pending' && retries < MAX_RETRIES) {
                await wait(RETRY_TIMEOUT);
                response = await BillingData.getMpsStatus(policeNummer);
                status = response.status;
                retries += 1;
            }

            if (retries === MAX_RETRIES) {
                throw new Error('Exceeded max retries for awaitGetMpsStatus.');
            }
        } catch (error) {
            if (error instanceof Error) throw error;
        }

        return response as MpsStatusResponseDTO;
    };

    return { awaitGetMpsStatus };
}
